import selectFocusedViewFilter from 'owa-mail-list-actions/lib/actions/selectFocusedViewFilter';
import { getSelectedTableView, getFocusedFilterForTable } from 'owa-mail-list-store';
/**
 * Called when rollup is clicked
 */
export default function onRollupClicked() {
    // - Switch to target Focused or Other pivot
    var targetPivotToSwitchTo = getFocusedFilterForTable(getSelectedTableView()) == 0 /* Focused */
        ? 1 /* Other */
        : 0 /* Focused */;
    selectFocusedViewFilter(targetPivotToSwitchTo, 'FocusedOtherRollup');
}
//# sourceMappingURL=onRollupClicked.js.map